import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
  container: {
    backgroundColor: 'transparent', // Let App.js dark background shine through
    minHeight: '100vh',
    padding: '80px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: '"Inter", sans-serif',
    color: '#f8fafc', // Light text
  },
  contentWrapper: {
    maxWidth: '800px',
    width: '100%',
  },
  // HEADER
  title: {
    fontSize: '3rem',
    fontWeight: '900',
    marginBottom: '20px',
    // Gradient fix for dark mode!
    background: 'linear-gradient(45deg, #ffffff, #b026ff)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent',
    letterSpacing: '-1px',
  },
  subtitle: {
    fontSize: '1.2rem',
    lineHeight: '1.6',
    color: '#94a3b8', // Slate grey
    marginBottom: '40px',
    borderLeft: '4px solid #b026ff', // Signature purple accent
    paddingLeft: '20px',
  },
  // SECTIONS
  section: {
    marginBottom: '50px',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#ffffff', // White
  },
  text: {
    fontSize: '1.05rem',
    lineHeight: '1.8',
    color: '#cbd5e1', // Light slate text for readability
    marginBottom: '20px',
  },
  highlight: {
    color: '#b026ff',
    fontWeight: 'bold',
  },
  // THE BREAKDOWN GRID
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginTop: '30px',
  },
  card: {
    backgroundColor: '#111c3a', // Dark Navy
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #1c2b4d', // Subtle blue border
    boxShadow: '0 8px 25px rgba(0,0,0,0.3)', // Dark shadow for depth
  },
  cardIcon: {
    fontSize: '2rem',
    marginBottom: '10px',
    display: 'block',
  },
  cardTitle: {
    fontWeight: 'bold',
    marginBottom: '5px',
    color: '#ffffff', // White
  },
  cardText: {
    fontSize: '0.9rem', 
    color: '#94a3b8', // Slate grey
    lineHeight: '1.5',
  },
  // TAGS
  tag: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  tagAssisted: {
    backgroundColor: 'rgba(176, 38, 255, 0.15)', // Translucent purple
    color: '#d8b4fe', // Light purple
    border: '1px solid rgba(176, 38, 255, 0.3)',
  },
  tagHuman: {
    backgroundColor: 'rgba(16, 185, 129, 0.15)', // Translucent green
    color: '#34d399', // Mint green
    border: '1px solid rgba(16, 185, 129, 0.3)',
  },
  tagHybrid: {
    backgroundColor: 'rgba(56, 189, 248, 0.15)', // Translucent blue
    color: '#7dd3fc', // Light blue
    border: '1px solid rgba(56, 189, 248, 0.3)',
  },
  tagContainer: {
    marginBottom: '10px',
  },
  // UPDATE BANNER
  updateBanner: {
    backgroundColor: 'rgba(16, 185, 129, 0.1)',
    border: '1px solid rgba(16, 185, 129, 0.4)',
    borderRadius: '12px',
    padding: '30px',
    marginBottom: '50px',
  },
  updateTitle: {
    color: '#34d399',
    fontSize: '1.6rem',
    fontWeight: 'bold',
    marginBottom: '15px',
    lineHeight: '1.3',
  },
  archivedLabel: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#94a3b8',
    marginBottom: '20px',
    marginTop: '40px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    borderBottom: '1px solid #334155',
    paddingBottom: '10px',
  },
  archivedContent: {
    opacity: 0.5,
    textDecoration: 'line-through',
    pointerEvents: 'none',
  },
  // FOOTER LINKS
  backContainer: {
    marginTop: '40px', 
    textAlign: 'center',
  },
  backLink: {
    color: '#b026ff', 
    fontWeight: 'bold', 
    textDecoration: 'none', 
    fontSize: '1.1rem',
  }
};

export default function AIPolicyPage() {
  return (
    <div style={styles.container}>
            <div style={styles.contentWrapper}>
        
        <h1 style={styles.title}>Our Stance on AI</h1>

        {/* UPDATE BANNER */}
        <div style={styles.updateBanner}>
          <h2 style={styles.updateTitle}>🎉 Update: We Are Going 100% Human for Assets!</h2>
          <p style={{...styles.text, color: '#f8fafc'}}>
            We are thrilled to announce that we are <strong>moving away from AI entirely for all game assets</strong>.
          </p>
          <p style={styles.text}>
            Thanks to some unexpected opportunities and occurrences, we recently secured the ability to pay for actual assets for our game 3XRay! When we first wrote the policy below, our stated goal was to use AI as a stepping stone until we could afford to hire human artists. We are proud to say we have reached that goal without having to actually release any game with AI to begin with.
          </p>
          <p style={styles.text}>
            Instead, it allowed us to show a vision and clear purpose, and that was enough to get us where we needed. Moving forward, Foreplay Games is leaving AI behind in favor of incredible, human-crafted art and assets.
          </p>
          <p style={styles.text}>
            With that said, we have a fair amount to replace, especially in the 3XRay page and external listings, and so be patient with us as we slowly replace everything AI related.
          </p>
          <p style={{...styles.text, marginBottom: 0, fontSize: '0.95rem', color: '#94a3b8'}}>
            <em>(For full transparency, we have kept our original policy below, struck through to reflect our new direction.)</em>
          </p>
        </div>

        <div style={styles.archivedLabel}>Archived Policy (Historical)</div>

        <div style={styles.archivedContent}>
          <p style={styles.subtitle}>
            We believe in transparency. Foreplay Games is a small indie studio with a limited budget 
            but unlimited ambition. To bridge that gap, we use Generative AI as a tool in our workflow.
          </p>

          {/* SECTION 1: THE PHILOSOPHY */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>We get it. It's controversial, especially in the creative space.</h2>
          <p style={styles.text}>
            We use AI to assist with asset generation, but the <span style={styles.highlight}>core</span> of our games, from the story, 
            the game design, and especially with the emotional beats, are all 100% human.
          </p>
          <p style={styles.text}>
            We do not use AI to replace creativity, rather we use it to execute our creative vision 
            at a scale that would otherwise be impossible for a small team such as ours to accomplish.
          </p>
        </div>

        {/* SECTION 2: THE GOAL */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Our Goal</h2>
          <p style={styles.text}>
            While we rely on AI for art in some of our projects, our long-term vision is different.
            Our ultimate goal as a studio is to transition to <span style={styles.highlight}>fully human-created assets</span>.
          </p>
          <p style={styles.text}>
            We ask for your trust. We are not using AI because we are wanting to take a shortcut, but due to the scale of our vision.
            AI simply makes that attainable for us right now. 
            We are well aware of the low-effort content flooding the market (the "AI slop"), and we refuse to be part of it. 
            Instead, we view AI as a <b>stepping stone</b>, and hope to leave it in the dust with time.
          </p>
          <p style={styles.text}>
            Our hope is that our first few projects succeed enough to provide us with the resources to hire 
            real human artists for our future titles, bringing even more soul and unique vision to the worlds we create.
          </p>
        </div>

        {/* SECTION 3: THE BREAKDOWN */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Where We Use It (And Where We Don't)</h2>
          
          <div style={styles.grid}>
            
            {/* ART */}
            <div style={styles.card}>
              <span style={styles.cardIcon}>🎨</span>
              <h3 style={styles.cardTitle}>Visual Arts</h3>
              <div style={styles.tagContainer}>
                <span style={{...styles.tag, ...styles.tagAssisted}}>AI Assisted</span>
              </div>
              <p style={styles.cardText}>
                Character sprites and backgrounds are generated using AI tools, then manually 
                retouched and composited by human hands.
              </p>
            </div>

            {/* WRITING */}
            <div style={styles.card}>
              <span style={styles.cardIcon}>✍️</span>
              <h3 style={styles.cardTitle}>Writing & Story</h3>
              <div style={styles.tagContainer}>
                <span style={{...styles.tag, ...styles.tagHuman}}>100% Human</span>
              </div>
              <p style={styles.cardText}>
                Every line of dialogue, every plot twist, and every character arc is written 
                by a human being. We do not use AI to write scripts.
              </p>
            </div>

            {/* VOICE */}
            <div style={styles.card}>
              <span style={styles.cardIcon}>🎙️</span>
              <h3 style={styles.cardTitle}>Voice Acting</h3>
              <div style={styles.tagContainer}>
                <span style={{...styles.tag, ...styles.tagHuman}}>100% Human</span>
              </div>
              <p style={styles.cardText}>
                We believe voice actors bring characters to life. We hire real voice talent 
                for our games.
              </p>
            </div>

            {/* CODE */}
            <div style={styles.card}>
              <span style={styles.cardIcon}>💻</span>
              <h3 style={styles.cardTitle}>Code & Engineering</h3>
              <div style={styles.tagContainer}>
                <span style={{...styles.tag, ...styles.tagHybrid}}>Hybrid</span>
              </div>
                            <p style={styles.cardText}>
                Core architecture is human-designed. We use AI assistants to speed up boilerplate 
                coding and debugging.
              </p>
            </div>

          </div>
        </div>
        </div> {/* End Archived Content */}
        
        <div style={styles.backContainer}>
          <Link to="/home" style={styles.backLink}>
            ← Back to Home
          </Link>
        </div>
        
      </div>
    </div>
  );
}